import { useTheme } from '../theme';

/**
 * Approved Obelisk artwork, shared by every application identity surface.
 *
 * Dark surfaces get their own export rather than a filter. The wordmark is
 * neutral ink and "AVOLIS" is the brand orange; inverting or desaturating the
 * whole image to suit a dark background would take the orange with it, so the
 * light-ink variant is drawn with that colour left exactly as approved.
 */
export function BrandLogo({ markOnly = false, decorative = false }: { markOnly?: boolean; decorative?: boolean }) {
  const { theme } = useTheme();
  const asset = `${markOnly ? 'mark' : 'logo'}${theme === 'dark' ? '-dark' : ''}`;
  return <img
    className={`brand-artwork${markOnly ? ' brand-artwork-mark' : ''}`}
    src={`/brand/obelisk-${asset}.svg`}
    width={markOnly ? 220 : 900}
    height={markOnly ? 349 : 336}
    alt={decorative ? '' : 'Obelisk by Avolis'}
    draggable={false}
    decoding="async"
  />;
}
